import { forwardRef, type Ref, type SVGProps } from "react";
const IconProfessionalOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M28 7.06h-5.3l-1.74-3.471A1.07 1.07 0 0 0 20 3h-8a1.07 1.07 0 0 0-.96.589L9.3 7.059H4a2.003 2.003 0 0 0-2 1.992v3.989a8.9 8.9 0 0 0 2 5.629v5.344A4.995 4.995 0 0 0 9 29h14c2.761 0 5-2.233 5-4.987V18.67a8.9 8.9 0 0 0 2-5.626V9.051a2.003 2.003 0 0 0-2-1.992M12.66 5.133h6.68l.96 1.925h-8.6zM27 16.637a6.85 6.85 0 0 0 1-3.59V9.05H4v3.992a6.85 6.85 0 0 0 1 3.59q.419.706 1 1.287a6.98 6.98 0 0 0 5 2.104v1.995a8.95 8.95 0 0 1-5-1.516v3.51a3.005 3.005 0 0 0 3 2.992h14a3.005 3.005 0 0 0 3-2.992v-3.507a8.95 8.95 0 0 1-5 1.516v-1.995a6.98 6.98 0 0 0 5-2.104 6.5 6.5 0 0 0 1-1.286"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M12.5 18.03a.5.5 0 0 1 .5.498v1.496h6v-1.496a.5.5 0 0 1 .5-.498h1a.5.5 0 0 1 .5.498v4.987a.5.5 0 0 1-.5.498h-1a.5.5 0 0 1-.5-.498v-1.497h-6v1.497a.5.5 0 0 1-.5.498h-1a.496.496 0 0 1-.5-.498v-4.987a.493.493 0 0 1 .5-.498z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconProfessionalOutlineSVG);
ForwardRef.displayName = "IconProfessionalOutline";
export { ForwardRef as IconProfessionalOutline };
